import * as audio from "./kernel/audio.js";

export {
    start
}

const MARK = '§';

let karaokeText;
const timeouts = [];

const karaokeData = [{"bar":2,"txt":"§[une voix qui s’excuse]"},{"bar":4,"txt":""},{"bar":5,"txt":"§[une voix narrative]"},{"bar":6,"txt":""},{"bar":7,"txt":"§[le piano se ferme]"},{"bar":8,"txt":""},{"bar":9,"txt":"§[les bois, les cuivres se retirent]"},{"bar":10,"txt":""},{"bar":11,"txt":"§[les percussions s’en vont]"},{"bar":12,"txt":""},{"bar":13,"txt":"§[les cordes se dispersent]"},{"bar":14,"txt":""},{"bar":15,"txt":"§[les premiers violons<br>sont déjà à l’hôtel]"},{"bar":16,"txt":""},{"bar":17,"txt":"§[je suis second]"},{"bar":18,"txt":""},{"bar":19,"txt":"§[la voix qui s’excuse disparaît]"},{"bar":20,"txt":""},{"bar":21,"txt":"§[c’est à vous je crois]"},{"bar":22,"txt":""},{"bar":23,"txt":"§[à vous]"},{"bar":24,"txt":""},{"bar":25,"txt":"Main droite§ la ligne"},{"bar":26,"txt":"D'horizon§ s'affine"},{"bar":27,"txt":"Des villes-§violons"},{"bar":28,"txt":"Dehors§ ils sont"},{"bar":29,"txt":"Penchés§ à peine"},{"bar":30,"txt":"Peuvent-ils§ se perdre ?"},{"bar":31,"txt":"La nuit§ les prend"},{"bar":32,"txt":"en ti§tubant"},{"bar":33,"txt":"Main droite§ la ville"},{"bar":34,"txt":"Des an§droïdes"},{"bar":35,"txt":"Sans feu§ sans âme"},{"bar":36,"txt":"Sous o§riflammes"},{"bar":37,"txt":"C'est kitsch§ pourtant"},{"bar":38,"txt":"Les glitchs§ d'écrans"},{"bar":39,"txt":"Restent me§naçants"},{"bar":40,"txt":"Omni§présents"},{"bar":42,"txt":""},{"bar":44,"txt":"Ce sont des formes§ abstraites"},{"bar":45,"txt":"Des symboles§ des feux"},{"bar":46,"txt":"Des croisements§ du sang"},{"bar":47,"txt":"Des articu§lations"},{"bar":48,"txt":"Ce sont des formes§ abstraites"},{"bar":49,"txt":"Des symboles"},{"bar":50,"txt":"Des feux§ des croisements"},{"bar":51,"txt":"Des articu§lations"},{"bar":52,"txt":"Main gauche§ le fil"},{"bar":53,"txt":"De la rivière§ dessine"},{"bar":54,"txt":"Des allées§ des allées"},{"bar":55,"txt":"Des allées§ des allées"},{"bar":56,"txt":"Main gauche§ le fil"},{"bar":57,"txt":"De la rivière§ dessine"},{"bar":58,"txt":"Des allées§ des allées"},{"bar":59,"txt":"Des Allez§ j'irai"},{"bar":60,"txt":"danser§ docile"},{"bar":61,"txt":"Sous les arbres§ mobiles"},{"bar":62,"txt":"Torsion§ clipping"},{"bar":63,"txt":"Rotations§ intimes"},{"bar":64,"txt":"Ô folle§ nature"},{"bar":65,"txt":"Oh pour moi§ dessine"},{"bar":66,"txt":"Un tapis de§ verdure"},{"bar":67,"txt":"Aux pixels§ acides"},{"bar":69,"txt":""},{"bar":76,"txt":"Ce sont des formes§ abstraites"},{"bar":77,"txt":"Des symboles§ des feux"},{"bar":78,"txt":"Des croisements§ du sang"},{"bar":79,"txt":"Des articu§lations"},{"bar":80,"txt":"Ce sont des formes§ abstraites"},{"bar":81,"txt":"Des symboles"},{"bar":82,"txt":"Des feux§ des croisements"},{"bar":83,"txt":"Des articu§lations"},{"bar":84,"txt":"Ce sont des formes§ abstraites"},{"bar":85,"txt":"Des symboles§ des feux"},{"bar":86,"txt":"Des croisements§ du sang"},{"bar":87,"txt":"Des articu§lations"},{"bar":88,"txt":"Ce sont des formes§ abstraites"},{"bar":89,"txt":"Des symboles"},{"bar":90,"txt":"Des feux§ des croisements"},{"bar":91,"txt":"Des articu§lations"},{"bar":92,"txt":"Des zones§ des zones"},{"bar":93,"txt":"Dézoome§ dézoome"},{"bar":94,"txt":"Des zones§ des zones"},{"bar":95,"txt":"Dézoome§ dézoome"},{"bar":96,"txt":"Des zones§ des zones"},{"bar":97,"txt":"Dézoome§ dézoome"},{"bar":98,"txt":"Des zones§ des zones"},{"bar":99,"txt":"Dézoome§ dézoome"},{"bar":100,"txt":"Des zones§ des zones"},{"bar":101,"txt":"Dézoome§ dézoome"},{"bar":102,"txt":"Des zones§ des zones"},{"bar":103,"txt":"Dézoome§ dézoome"},{"bar":105,"txt":""},{"bar":107,"txt":"§[L'orchestre est parti]"},{"bar":109,"txt":""},{"bar":112,"txt":"§[Forcément]"},{"bar":114,"txt":""},{"bar":116,"txt":"§[Tout est vide]"},{"bar":117,"txt":""},{"bar":118,"txt":"§[Enfin]"},{"bar":120,"txt":""}];

function start() {
    karaokeText = document.getElementById('karatext');

    // Play signal sound
    audio.buffers.play('karappo', {
        onended: () => {
            clean();
            // TODO: EXIT ?
        },
    });

    createKaraokeEvents();
}

function createKaraokeEvents() {
    const beginAtBar = 0;
    karaokeText.innerHTML = '&nbsp;';
    karaokeData.forEach(d => {
        if (d.bar >= beginAtBar) {
            let from = 0;
            let to = 100;
            let dual = false;
            const time = d.bar * 2.4 + 2.4 - beginAtBar * 2.4;
            if (d.txt.includes(MARK) && d.txt[0] !== MARK) {
                // This text includes a § marker, animate it in two parts
                dual = true;
                to = getTextWidthPercentageBeforeMarker(d.txt, karaokeText);
            }
    
            const cleanText = d.txt.replaceAll(MARK, '');

            // Handle no animation if MARK in on first char
            if (d.txt[0] == MARK) to = 0;
    
            // Phase 1 (might be the only one)
            timeouts.push(setTimeout(() => {
                karaokeText.innerHTML = `<span
                    data-text="${cleanText}"
                    style="
                        --karatext-animate-from: 0%;
                        --karatext-animate-to: ${to}%;
                    "
                >${cleanText || '&nbsp;'}</span>`;
            }, (time - 0.6) * 1000));
    
            // Phase 2 (only if marker present)
            if (dual) {
                timeouts.push(setTimeout(() => {
                    karaokeText.innerHTML = `<span
                        data-text="${cleanText}"
                        style="
                            --karatext-animate-from: ${to}%;
                            --karatext-animate-to: 100%;
                        "
                    >${cleanText || '&nbsp;'}</span>`;
                }, (time + 0.6) * 1000));
            }
        }
    });
}

// Source for getTextWidth(), getCssStyle() and getCanvasFont(): https://stackoverflow.com/a/21015393
function getTextWidth(text, font) {
    // re-use canvas object for better performance
    const canvas = getTextWidth.canvas || (getTextWidth.canvas = document.createElement("canvas"));
    const context = canvas.getContext("2d");
    context.font = font;
    const metrics = context.measureText(text);
    return metrics.width;
}

function getCssStyle(element, prop) {
    return window.getComputedStyle(element, null).getPropertyValue(prop);
}

function getCanvasFont(el = document.body) {
    const fontWeight = getCssStyle(el, 'font-weight') || 'normal';
    const fontSize = getCssStyle(el, 'font-size') || '16px';
    const fontFamily = getCssStyle(el, 'font-family') || 'Times New Roman';

    return `${fontWeight} ${fontSize} ${fontFamily}`;
}

function getTextWidthPercentageBeforeMarker(txt, element) {
    const font = getCanvasFont(element);
    const textFragment = txt.substring(0, txt.indexOf(MARK));
    const cleanText = txt.replaceAll(MARK, '');
    const fragmentWidth = getTextWidth(textFragment, font);
    const totalWidth = getTextWidth(cleanText, font);
    return fragmentWidth/totalWidth * 100;
}

function clearTimeouts() {
    timeouts.forEach(t => clearTimeout(t));
}

function clean () {
    clearTimeouts();
    karaokeText.innerHTML = '';
    audio.fadeOutAll(1);
}
